const locale = {
	// #region Requests fields
	DETAILS_REQUESTS_FIELD_TITLE: 'Title',
	DETAILS_REQUESTS_FIELD_WARNING: 'Warning',
	DETAILS_REQUESTS_FIELD_BLOCKED: 'Blocked',
	DETAILS_REQUESTS_FIELD_STATUS: 'Requests Status',
	DETAILS_REQUESTS_FIELD_TYPE: 'Requests Type',
	DETAILS_REQUESTS_FIELD_SIGNALLER_USER: 'Signaller User',
	DETAILS_REQUESTS_FIELD_ASSIGNED_USER: 'Assigned User',
	DETAILS_REQUESTS_FIELD_DATE_FROM: 'Started processing date',
	DETAILS_REQUESTS_FIELD_DATE_TO: 'Closure date',
	DETAILS_REQUESTS_FIELD_DATE_CREATED: 'Creation date',
	DETAILS_REQUESTS_FIELD_USER_CLOSED: 'Closed by',
	DETAILS_REQUESTS_FIELD_CLOSED_REASON: 'Close Reason',
	DETAILS_REQUESTS_FIELD_TAGS: 'Tags',
	// #endregion

	DETAILS_HEADER_BUTTON_REQUESTS_DOCUMENTS_SETTINGS: 'Docs configuration'
};

export default locale;
